import React from 'react';
import { Helmet } from 'react-helmet-async';

const Terms = () => {
  return (
    <>
      <Helmet>
        <title>Terms & Conditions | Fort Worth Dental</title>
        <meta name="description" content="Read the Terms and Conditions for Fort Worth Dental website. Understand the rules and guidelines for using our dental services website." />
      </Helmet>
      
      <div className="min-h-screen bg-gray-50">
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-teal-600 to-teal-800 text-white py-12">
          <div className="container mx-auto px-4 text-center">
            <h1 className="text-3xl sm:text-4xl font-bold mb-2">Terms & Conditions</h1>
            <p className="text-lg">Last Updated: January 1, 2024</p>
          </div>
        </section>

        <div className="container mx-auto px-4 py-12">
          <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md p-8">
            
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">Agreement to Terms</h2>
              <p className="text-gray-700 mb-4">
                Welcome to Fort Worth Dental. These Terms and Conditions ("Terms") govern your use of our website located at fortworthdental.com (the "Website") and any related services provided by Fort Worth Dental.
              </p>
              <p className="text-gray-700 mb-4">
                By accessing or using the Website, you agree to be bound by these Terms. If you disagree with any part of the Terms, you may not access the Website.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">Medical Disclaimer</h2>
              <p className="text-gray-700 mb-4">
                The content on this Website is provided for general informational purposes only and is not intended as, nor should it be considered a substitute for, professional medical or dental advice. Always seek the advice of your dentist or other qualified health provider with any questions you may have regarding a medical or dental condition.
              </p>
              <p className="text-gray-700 mb-4">
                Never disregard professional dental advice or delay in seeking it because of something you have read on this Website. If you think you may have a dental emergency, call your dentist or 911 immediately.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">Use of Website</h2>
              <p className="text-gray-700 mb-4">
                You may use the Website only for lawful purposes and in accordance with these Terms. You agree not to:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                <li>Use the Website in any way that violates any applicable federal, state, local, or international law or regulation</li>
                <li>Engage in any conduct that restricts or inhibits anyone's use or enjoyment of the Website</li>
                <li>Attempt to gain unauthorized access to any portion of the Website</li>
                <li>Use any robot, spider, or other automatic device to monitor or copy any portion of the Website</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">Intellectual Property</h2>
              <p className="text-gray-700 mb-4">
                The Website and its original content, features, and functionality are owned by Fort Worth Dental and are protected by international copyright, trademark, patent, trade secret, and other intellectual property laws.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">Appointment Scheduling</h2>
              <p className="text-gray-700 mb-4">
                When you schedule an appointment through our Website, you agree to:
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                <li>Provide accurate and complete information</li>
                <li>Arrive on time for your scheduled appointment</li>
                <li>Provide at least 24 hours notice if you need to cancel or reschedule</li>
                <li>Pay for services rendered according to our payment policies</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">Limitation of Liability</h2>
              <p className="text-gray-700 mb-4">
                In no event shall Fort Worth Dental, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">Changes to Terms</h2>
              <p className="text-gray-700 mb-4">
                We reserve the right to modify or replace these Terms at any time. If a revision is material, we will provide at least 30 days notice prior to any new terms taking effect. What constitutes a material change will be determined at our sole discretion.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">Governing Law</h2>
              <p className="text-gray-700 mb-4">
                These Terms shall be governed by and defined following the laws of the State of Texas. Fort Worth Dental and yourself irrevocably consent that the courts of Texas shall have exclusive jurisdiction to resolve any dispute which may arise in connection with these Terms.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">Contact Us</h2>
              <p className="text-gray-700 mb-4">
                If you have any questions about these Terms, please contact us:
              </p>
              <div className="bg-gray-100 p-4 rounded-lg">
                <p className="text-gray-700"><strong>Fort Worth Dental</strong></p>
                <p className="text-gray-700">4620 Citylake Blvd W</p>
                <p className="text-gray-700">Fort Worth, TX 76132</p>
                <p className="text-gray-700">Phone: (817) 985-3337</p>
                <p className="text-gray-700">Website: fortworthdental.com</p>
              </div>
            </section>

          </div>
        </div>
      </div>
    </>
  );
};

export default Terms;
